import { _userLevel } from 'ecp/models/UsersModel'

const AttorneyModel = {
  isDisabledAttorneyFormSubmitButton: (userLevel: _userLevel) => (userLevel === 'auditor'),

  canAddAttorney: (userLevel: _userLevel) => (userLevel !== 'auditor')
}

export default AttorneyModel
